const zh = {
    '/': {
        title: '{brand} | 体育博彩、真人娱乐场 & 即时提款',
        description: '在{brand}玩老虎机、真人娱乐场并参与体育博彩。支持即时提款、可验证公平游戏和24/7支持的加密货币赌场。'
    },
    '/casino': {
        title: '在线娱乐场 | 老虎机、21点 & 真人荷官 | {brand}',
        description: '在{brand}玩老虎机、21点、轮盘 & 真人荷官。数百种游戏，快速加密货币存款 & 24/7即时提款。'
    },
    '/sports': {
        title: '在线体育博彩 | 加密货币体育投注 & 赔率 | {brand}',
        description: '在{brand}进行体育博彩。足球、篮球等具有竞争力的赔率。现场投注、安全的加密货币下注 & 快速支付。'
    },
    '/livecasino': {
        title: '真人娱乐场 | 21点、轮盘 & 真人荷官 | {brand}',
        description: '在{brand}玩21点、轮盘 & 真人娱乐场游戏。真实荷官，高清直播 & 24/7丰富真人桌台。'
    },
    '/slots': {
        title: '在线老虎机 | 海量娱乐场老虎机 | {brand}',
        description: '在{brand}旋转海量老虎机合集。经典水果机、视频老虎机 & 累积奖金，均可使用加密货币游玩。'
    },
    '/vip': {
        title: 'VIP计划 | 专属奖励 & 福利 | {brand}',
        description: '{brand}的VIP计划：专属奖励、个性化奖金和优先支持。为忠实玩家量身定制的特权。'
    },
    '/welcome-offer': {
        title: '欢迎优惠 | 加密货币娱乐场 | {brand}',
        description: '了解{brand}的欢迎优惠。使用加密货币开始游戏，享受新玩家专属福利。'
    },
    '/referral': {
        title: '推荐计划 | 赚取奖励 | {brand}',
        description: '邀请朋友加入{brand}，当他们注册并满足条件时即可赚取奖励。分享您的推荐链接，开始赚取。'
    },
    '/promotion-page': {
        title: '促销活动 | 奖金 & 特别优惠 | {brand}',
        description: '浏览{brand}所有活跃促销。加密货币玩家专享的奖金、免费旋转和特别优惠。'
    },
    '/hotslots': {
        title: '热门老虎机 | 热门娱乐场老虎机 | {brand}',
        description: '在{brand}玩最受欢迎的老虎机。支持加密货币的热门老虎机一应俱全。'
    },
    '/newgames': {
        title: '新游戏 | 最新娱乐场游戏 | {brand}',
        description: '探索{brand}最新的娱乐场游戏。新老虎机、真人游戏和桌游不断上线。'
    },
    '/populargames': {
        title: '热门游戏 | 最受欢迎娱乐场游戏 | {brand}',
        description: '{brand}最受欢迎的娱乐场游戏。从老虎机到真人游戏，全部支持加密货币。'
    },
    '/gameshows': {
        title: '游戏节目 | 真人游戏节目娱乐场 | {brand}',
        description: '在{brand}享受真人游戏节目。真实主持人现场互动，独特游戏玩法，丰厚奖励。'
    },
    '/table_games': {
        title: '桌游 | 21点、轮盘 & 百家乐 | {brand}',
        description: '在{brand}玩21点、轮盘、百家乐等桌游。全部支持加密货币游玩。'
    },
    '/hotlive': {
        title: '热门真人娱乐场 | 热门真人游戏 | {brand}',
        description: '{brand}最受欢迎的真人娱乐场游戏。与真实荷官实时互动游戏。'
    },
    '/featurebuyin': {
        title: '特购功能老虎机 | 直购奖励轮老虎机 | {brand}',
        description: '在{brand}玩支持购买特购功能的老虎机。直接进入奖励轮，无需等待触发。'
    }
};
export default zh;
